import { useState } from "react"
import styled from "styled-components"

const google_drive_file_id = "1xsn82HC3Rhg5GoCyQs8W3shcAjj2vM1M"
const guide_pdf_url = `https://drive.google.com/file/d/${google_drive_file_id}/preview`

export const DocsGuidePage = () => {
  const [isLoading, setIsLoading] = useState(true)

  const onLoad = () => {
    setIsLoading(false)
  }

  return (
    <StyledDocsGuidePage className={isLoading ? "loading" : ""}>
      <div className="loading">
        <strong>메뉴얼 로딩중입니다</strong>
        <span>잠시만 기다려주세요</span>
      </div>

      <iframe className="guide" src={guide_pdf_url} onLoad={onLoad} />
    </StyledDocsGuidePage>
  )
}

const StyledDocsGuidePage = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  display: flex;

  & > .loading {
    transition: opacity 200ms;
    opacity: 0;
    pointer-events: none;
    z-index: 1;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: grid;
    gap: 10px;
    text-align: center;

    & > strong {
      font-size: 30px;
    }
    & > span {
      font-size: 20px;
    }
  }
  & > .guide {
    transition: opacity 200ms;
    z-index: 2;
    flex: 1;
  }
  &.loading {
    & > .loading {
      opacity: 1;
    }
    & > .guide {
      opacity: 0;
    }
  }
`